// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson <hi@ben.gy>
// Additional permissions under AGPL-3.0 section 7 — see ADDITIONAL-TERMS.md.

export const GLOSSARY: Record<string, string> = {
  audiogram:
    'A short video that turns audio into something social platforms will play — a still or animated background with a moving waveform and (often) a caption.',
  waveform:
    'A visual drawing of an audio signal’s loudness over time. Wavewell animates it in sync with the sound.',
  webcodecs:
    'A browser API that gives web pages direct access to the device’s built-in video and audio encoders — so Wavewell can make an MP4 without a server.',
  h264:
    'H.264 (AVC) is the video codec inside the MP4 Wavewell exports. It plays on essentially every phone, browser and social platform.',
  aac: 'AAC is the audio codec used inside the MP4 — the standard for MP4 audio, widely supported.',
  mp4: 'A container file holding the H.264 video and AAC audio together. It’s the format social platforms expect.',
  fft: 'Fast Fourier Transform — the maths that splits a slice of sound into its frequencies, so the dancing bars can react to bass and treble separately.',
  offscreencanvas:
    'A canvas that can be drawn to inside a background worker thread, so rendering every frame doesn’t freeze the page.',
};
